module.exports = __webpack_public_path__ + "img/shil_shippletoken.fc2f472.png";